import { __assign, __makeTemplateObject, __rest } from "tslib";
/**
 * this file origin from Mui source to change below Tabs content
 * ! just change the MuiTabs component to our RcTabs
 * https://github.com/mui-org/material-ui/blob/master/packages/material-ui-lab/src/TabList/TabList.js
 */
import React, { forwardRef, useMemo } from 'react';
import { combineClasses, styled, useThemeProps, } from '../../../foundation';
import { getPanelId, getTabId, useTabContext, } from '../TabContext';
import { RcTabs } from '../Tabs';
import { TabListStyle } from './styles';
import { RcTabListClasses } from './utils';
var _RcTabList = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcTabList' });
    var classesProp = props.classes, childrenProp = props.children, idPrefix = props.idPrefix, value = props.value, rest = __rest(props, ["classes", "children", "idPrefix", "value"]);
    var classes = useMemo(function () { return combineClasses(RcTabListClasses, classesProp); }, [classesProp]);
    var tabContext = useTabContext();
    var context = useMemo(function () { return ({
        value: value !== null && value !== void 0 ? value : tabContext === null || tabContext === void 0 ? void 0 : tabContext.value,
        idPrefix: idPrefix !== null && idPrefix !== void 0 ? idPrefix : tabContext === null || tabContext === void 0 ? void 0 : tabContext.idPrefix,
    }); }, [value, idPrefix, tabContext]);
    if (!tabContext && !context.idPrefix) {
        throw new Error('[TabList] No idPrefix provided, use RcTabContext or idPrefix prop');
    }
    var children = useMemo(function () {
        return React.Children.map(childrenProp, function (child) {
            var value = child.props.value;
            return React.cloneElement(child, {
                'aria-controls': getPanelId(context, value),
                id: getTabId(context, value),
            });
        });
    }, [childrenProp, context]);
    return (React.createElement(RcTabs, __assign({}, rest, { ref: ref, classes: classes, value: context.value }), children));
});
var RcTabList = styled(_RcTabList)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), TabListStyle);
RcTabList.defaultProps = {};
RcTabList.displayName = 'RcTabList';
export { RcTabList };
var templateObject_1;
